<!-- 部门文件管理 -->
<template>
  <div class="page_content">
    <departmentFileManagementAction ref="departmentFileManagementAction"></departmentFileManagementAction>
    <div class="page_content_top">
      <v-button :buttonList="buttonList" @actionSet="actionSet" :buttonFlag="false"></v-button>
      <div class="page_content_top_line">
        <el-form :inline="true" :model="getRequestData" class="demo-form-inline" label-width="100px">
          <el-form-item label="开始时间">
            <label slot="label" :style="$common.labelStyle('开始时间')" v-html="'开始时间'"></label>
            <el-date-picker v-model="getRequestData.start" type="date" placeholder="选择日期" format="yyyy 年 MM 月 dd 日"
              value-format="timestamp" clearable></el-date-picker>
          </el-form-item>
          <el-form-item label="结束时间">
            <label slot="label" :style="$common.labelStyle('结束时间')" v-html="'结束时间'"></label>
            <el-date-picker v-model="getRequestData.end" type="date" placeholder="选择日期" format="yyyy 年 MM 月 dd 日"
              value-format="timestamp" clearable></el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="mini" @click="searchData">查询</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="page_content_center">
      <el-table size="mini" stripe :data="returnData.list" :height="tableHeight" :key="$store.state.tableNum" border
        style="width: 100%" highlight-current-row>
        <el-table-column align="center" label="选择操作" width="80">
          <template slot-scope="scope">
            <el-radio v-model="selectedDataIndex" :label="scope.$index" border size="mini">
              <i class="el-icon-thumb"></i>
            </el-radio>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="depName" label="部门名称" width="180">
        </el-table-column>
        <el-table-column align="center" prop="depFileId" label="文件ID" width="100">
        </el-table-column>
        <el-table-column align="center" prop="files" label="文件">
          <template slot-scope="scope" v-if="scope.row.files">
            <ul class="upload_ul">

              <li v-for="(val, key) in scope.row.files.split(',')" :key="key">
                <cusImage style="width: 20px; height: 20px" :src="`${imgUrl}/${val}`"
                  :preview-src-list="[`${imgUrl}/${val}`]">
                </cusImage>
              </li>
            </ul>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="info" label="文件说明">
        </el-table-column>
        <el-table-column align="center" prop="createrName" label="创建人">
        </el-table-column>
        <el-table-column align="center" prop="createrName" label="创建时间">
          <template slot-scope="scope">
            <span v-if="scope.row.createTime">
              {{ $common.getLocalTime(scope.row.createTime) }}
            </span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="page_content_bottom">
      <v-pagination :page="getRequestData.page" :rows="getRequestData.rows" :total="returnData.total"
        @setDataPageSize="setDataPageSize" @setDataPageNumber="setDataPageNumber"></v-pagination>
    </div>
    <!-- 人员列表 -->
    <el-dialog title="人员列表" v-if="perDia" :visible.sync="perDia">
      <div style="margin-bottom: 15px;">
        <el-input v-model="searchPersonName" placeholder="请输入人员姓名进行筛选" clearable style="width: 300px;"
          @input="handlePersonSearch" @clear="handlePersonSearch" @keyup.enter.native="handlePersonSearch">

        </el-input>
        <el-button style="border-radius: 0;" type="primary" @click="handlePersonSearch">搜索</el-button>
      </div>
      <el-table :data="perList" ref="perList" border @selection-change="handleSelectionChange" height="450px"
        size="mini" v-loading="loading">
        <el-table-column type="selection" width="40"></el-table-column>
        <el-table-column property="opmName" label="人员姓名" show-overflow-tooltip></el-table-column>
        <el-table-column property="opmIdnumber" label="人员身份证" show-overflow-tooltip></el-table-column>
        <el-table-column property="opmMobilenumber" label="人员手机号" show-overflow-tooltip></el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="perDia = false">取 消</el-button>
        <el-button type="primary" @click="selPerson">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import departmentFileManagementAction from "@/components/departmentFileManagementAction.vue";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {departmentFileManagementAction},
  data() {
    var _this = this;
    //这里存放数据
    return {
      imgUrl: window.global_config.BASE_IMG_URL,
      tableHeight: 0,
      dataActionBox: {
        showStatus: false,
        openMode: "ltr" || "rtl",
        boxTitle: "",
        actionType: 0, // 0新增，1修改
      },
      selectedDataList: [],
      buttonList: [],
      getRequestData: {
        start:
          new Date(new Date().toLocaleDateString()).getTime() -
          31 * 24 * 3600 * 1000,
        end:
          new Date(new Date().toLocaleDateString()).getTime() +
          24 * 60 * 60 * 1000 -
          1,
        page: 1,
        rows: 30,
        creater: "",
      },
      returnData: {
        pages: 0, // 总页数
        total: 0, // 总条数
        pageNum: 0, // 当前页数
        list: [],
      },
      selectedDataIndex: 0,
      requesUrl: "",
      perDia: false,
      perList: [],
      loading: false,
      searchPersonName: "",
      selectedRowIndex: null,
      multipleSelection: [],
      PeopleList: [],
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    imgurl() {
      // console.log(this.$store.getters.getConfig);
      this.requesUrl = this.$store.getters.getConfig.requestUrl;
      this.imgUrl = this.$store.getters.getConfig.imgUrl;
    },

    // 动作集合
    actionSet(actionData) {
      console.log(actionData.actionType, "actionData.actionType");
      switch (actionData.actionType) {
        case 0:
          this.$refs["departmentFileManagementAction"].openBox(
            actionData.actionType
          );
          break;
        case 1:
          if (this.returnData.list <= 0) {
            this.$message({
              message: "暂无数据",
              type: "error",
            });
            return false;
          }
          var dataInfo = this.returnData.list[this.selectedDataIndex];
          if (!dataInfo) {
            this.$message({
              message: "请先选中要操作的数据",
              type: "error",
            });
            return false;
          }
          this.$refs["departmentFileManagementAction"].openBox(
            actionData.actionType,
            dataInfo
          );
          break;
        case 2:
          this.delDataAction();
          break;
        case 10:
          this.downAction();
          break;
        case 11:
          if (this.returnData.list <= 0) {
            this.$message({
              message: "暂无数据",
              type: "error",
            });
            return false;
          }
          var dataInfo = this.returnData.list[this.selectedDataIndex];
          if (!dataInfo) {
            this.$message({
              message: "请先选中要操作的数据",
              type: "error",
            });
            return false;
          }
          this.bindPeople()
          break;
      }
    },
    //  查看图片
    lookImg(row) {
      console.log(row);
      this.srcList = [];
      var arr = row.fileUrl.split(",");
      arr.forEach((item) => {
        this.srcList.push(this.imgUrl + "/" + item);
      });
    },

    async getButtonList() {
      this.buttonList = await this.$common.getActionButton();
    },
    // 数据搜索
    searchData() {
      this.getRequestData.page = 1;
      this.getDataList();
    },

    // 删除数据
    delDataAction() {
      if (this.returnData.list <= 0) {
        this.$message({
          message: "暂无数据",
          type: "error",
        });
        return false;
      }
      var dataInfo = this.returnData.list[this.selectedDataIndex];
      if (!dataInfo) {
        this.$message({
          message: "请先选中要操作的数据",
          type: "error",
        });
        return false;
      }
      this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          var delData = {
            ids: [dataInfo.depFileId],
          };
          let responseData = await this.$http.delDepartFile(delData);
          if (responseData.status == 200) {
            this.$message({
              type: "success",
              message: "删除成功!",
            });
            this.getDataList();
          } else {
            this.$message({
              message: responseData.message,
              type: "error",
            });
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        })
        .catch(() => { });
    },
    // 下载数据
    downAction() {
      if (this.returnData.list <= 0) {
        this.$message({
          message: "暂无数据",
          type: "error",
        });
        return false;
      }
      var dataInfo = this.returnData.list[this.selectedDataIndex];
      if (!dataInfo) {
        this.$message({
          message: "请先选中要操作的数据",
          type: "error",
        });
        return false;
      }
      if (!dataInfo.files) {
        this.$message({
          message: "选中的数据，没有文件可以下载",
          type: "error",
        });
        return false;
      }

      window.location.href = this.requesUrl + '/DepartFile/zipFile?files=' + dataInfo.files.toString()
    },
    //   新增人员
    bindPeople() {
      this.perDia = true;
      this.searchPersonName = ""; // 重置搜索条件
      this.queryOperator();
    },
    // 人员搜索处理
    handlePersonSearch() {
      this.queryOperator();
    },
    //查询人员列表
    async queryOperator() {
      this.loading = true;
      let params = {
        page: 1,
        rows: 1000,
        opmName: this.searchPersonName || "",
      };
      let responseData = await this.$http.queryOperator(params);
      this.loading = false;
      if (responseData && responseData.status == 200) {
        this.perList = [];
        responseData.result.list.forEach((item) => {
          this.perList.push({
            opmName: item.opmName,
            opmId: item.opmId,
            opmIdnumber: item.opmIdnumber,
            opmMobilenumber: item.opmMobilenumber,
            depName: item.depName,
            reviewerCondition: "",
          });
        });

      } else {
        this.$message({
          message: responseData.message,
          type: "error",
        });
      }
      this.getBindPeople()
    },
    async getBindPeople() {
      // 获取绑定人员
      const responseData = await this.$http.getBindMemByFileId({ ids: [this.returnData.list[this.selectedDataIndex].depFileId] })
      if (responseData && responseData.status == 200) {
        console.log(responseData, 'responseData333');

        // 根据返回的绑定人员信息，在人员列表中预选对应的人员
        if (responseData.result && responseData.result.length > 0) {
          // 提取已绑定人员的memId列表
          const boundMemIds = responseData.result.map(item => item.memId);

          // 在下一个tick中设置选中状态，确保表格已经渲染完成
          this.$nextTick(() => {
            // 清除之前的选择
            this.$refs.perList.clearSelection();

            // 遍历人员列表，选中已绑定的人员
            this.perList.forEach((person) => {
              if (boundMemIds.includes(person.opmId)) {
                this.$refs.perList.toggleRowSelection(person, true);
              }
            });
          });
        } else {
          // 如果没有绑定人员，清除所有选择
          this.$nextTick(() => {
            this.$refs.perList.clearSelection();
          });
        }
      } else {
        this.$message({
          message: responseData.message,
          type: "error",
        });
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    async selPerson() {
      // 只添加未存在于PeopleList中的人员
      const existIds = this.PeopleList.map(item => item.opmId);
      const addList = this.multipleSelection.filter(item => !existIds.includes(item.opmId));

      // 准备保存的数据
      let pushData = {
        memIdList: addList.map(item => item.opmId),
        depFileId: this.returnData.list[this.selectedDataIndex].depFileId,
      };

      // 直接调用保存接口
      let responseData = await this.$http.bindMem(pushData);
      if (responseData.status == 200) {
        this.$message({
          message: "操作成功",
          type: "success",
        });
        this.getDataList();
        // 关闭对话框
        this.perDia = false;
      } else {
        this.$message({
          message: responseData.message,
          type: "error",
        });
      }
    },
    // 数据翻页
    setDataPageNumber(val) {
      this.getRequestData.page = val;
      this.getDataList();
    },

    // 切换显示条数
    setDataPageSize(val) {
      this.getRequestData.page = 1;
      this.getRequestData.rows = val;
      this.getDataList();
    },
    // 获取数据列表
    async getDataList() {
      let responseData = await this.$http.queryDepartFileInit(
        this.getRequestData
      );
      if (responseData.status == 200) {
        this.returnData.list = responseData.result.list;
        this.returnData.pages = responseData.result.pages;
        this.returnData.total = responseData.result.total;
        this.returnData.pageNum = responseData.result.pageNum;
        this.selectedDataIndex = 0;
      } else {
        this.$message({
          message: responseData.message,
          type: "error",
        });
      }
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.imgurl();
    this.getDataList();
    this.getButtonList();
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() { },
  beforeCreate() { }, //生命周期 - 创建之前
  beforeMount() { }, //生命周期 - 挂载之前
  beforeUpdate() { }, //生命周期 - 更新之前
  updated() {
    this.tableHeight = this.$common.getTableHeight();
  }, //生命周期 - 更新之后
  beforeDestroy() { }, //生命周期 - 销毁之前
  destroyed() { }, //生命周期 - 销毁完成
  activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.upload_ul {
  width: 280px;
  list-style: none;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.upload_ul li {
  position: relative;
  width: 22px;
  height: 22px;
  margin-right: 3px;
  margin-bottom: 3px;
  border: 1px solid #dedede;
}

.upload_ul li .del {
  display: none;
  position: absolute;
  top: -1px;
  right: -1px;
  font-size: 10px;
  z-index: 99;
  cursor: pointer;
}

.upload_ul li .del:hover {
  color: #409eff;
}

.upload_ul li:hover .del {
  display: inline-block;
}

.upload_ul li ::v-deep .el-image__error {
  font-size: 5px;
}

.upload_ul li ::v-deep .cus-image {
  width: 20px !important;
  height: 20px !important;
}

.upload_ul li ::v-deep .cus-image img {
  width: 20px !important;
  height: 20px !important;
}
</style>
